// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"40bb8fc7","155":"b8c55d86"}[chunkId] + ".chunk.css";
};